<template>
    <div class="page-wrapper">
        <div class="updated-message-wrapper" v-if="successUpdateMessage">
            <div class="updated-message" style="display: block;">
                <p><img src="/assets/img/checkbox-outline.svg" alt="">{{ successUpdateMessage }}</p>
            </div>
        </div>
        <div class="container-fluid" v-if="setTitleState">
            <div class="row mt-5">
                <div class="col-12">
                    <div class="share-pictures-wrapper">
                        <div class="save-document-form">
                            <h2>Create a Playlist</h2>
                            <h4 class="sub-heading"Create a playlist of Youtube videos and share it with anyone.</h4>
                            <p>Save this as a document, you find it in your documents section</p>
                            <div class="form-group">
                                <div class="form-field">
                                    <input type="text"
                                           v-model="formData.name"
                                           placeholder="Document Name" class="form-control"/>
                                    <div class="field-check" v-show="formData.name.replace(/(\r\n|\n|\r)/gm,'')"></div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="form-field">
                                    <textarea class="form-control" v-model="formData.description"
                                              placeholder="Description..."></textarea>
                                    <div class="field-check" v-show="formData.description"></div>
                                </div>
                            </div>
                            <div class="form-group mt-4">
                                <div class="custom-control form-field" v-if="userData && userData.team_id">
                                       <span class="switch switch-sm">
                                        <input type="checkbox" class="switch" v-model="formData.team_shared"
                                               id="switch-stm">
                                        <label for="switch-stm">Save as a Team Document</label>
                                      </span>
                                    <div class="share-document-info">
                                        <a href="javascript:" @mouseover="team_share_tooltip = true"
                                           @mouseout="team_share_tooltip = false">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="20"
                                                 viewBox="0 0 23 20">
                                                <g>
                                                    <g>
                                                        <path
                                                            d="M11.43 11.5c-.46 0-.831-.387-.831-.865v-5.77c0-.478.372-.865.83-.865.46 0 .831.387.831.865v5.77c0 .478-.372.865-.83.865zM.629 9.75C.629 4.365 5.464 0 11.429 0c5.966 0 10.802 4.365 10.802 9.75S17.395 19.5 11.43 19.5C5.464 19.5.629 15.135.629 9.75zm19.94 0c0-4.556-4.092-8.25-9.14-8.25-5.047 0-9.139 3.694-9.139 8.25S6.382 18 11.43 18c5.047 0 9.139-3.694 9.139-8.25zm-9.97 5c0-.414.372-.75.83-.75.46 0 .831.336.831.75s-.371.75-.83.75c-.46 0-.831-.336-.831-.75z"></path>
                                                    </g>
                                                </g>
                                            </svg>
                                        </a>
                                        <div class="share-document-box" onclick="return null;"
                                             v-if="team_share_tooltip">
                                            <p>Saving as a Team Document will add this to your Team's Documents section
                                                and will be visible to all your Team Members.</p>
                                            <p class="mt-3">Note - Team Documents cannot be shared as Community
                                                Documents.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="custom-control form-field">
                                       <span class="switch switch-sm">
                                        <input type="checkbox" class="switch" v-model="formData.shared" id="switch-sm">
                                        <label for="switch-sm">Share as a Community Document</label>
                                      </span>
                                    <div class="share-document-info">
                                        <a href="javascript:" @mouseover="share_tooltip = true"
                                           @mouseout="share_tooltip = false">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="20"
                                                 viewBox="0 0 23 20">
                                                <g>
                                                    <g>
                                                        <path
                                                            d="M11.43 11.5c-.46 0-.831-.387-.831-.865v-5.77c0-.478.372-.865.83-.865.46 0 .831.387.831.865v5.77c0 .478-.372.865-.83.865zM.629 9.75C.629 4.365 5.464 0 11.429 0c5.966 0 10.802 4.365 10.802 9.75S17.395 19.5 11.43 19.5C5.464 19.5.629 15.135.629 9.75zm19.94 0c0-4.556-4.092-8.25-9.14-8.25-5.047 0-9.139 3.694-9.139 8.25S6.382 18 11.43 18c5.047 0 9.139-3.694 9.139-8.25zm-9.97 5c0-.414.372-.75.83-.75.46 0 .831.336.831.75s-.371.75-.83.75c-.46 0-.831-.336-.831-.75z"></path>
                                                    </g>
                                                </g>
                                            </svg>
                                        </a>
                                        <div class="share-document-box" onclick="return null;" v-if="share_tooltip">
                                            <p>Sharing this as a Community Document allows anyone using the Analyst Hub
                                                to see your document.
                                                This might be useful if you are looking for feedback or if you simply
                                                enjoy sharing your crafts with like-minded people.</p>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <span class="invalid-feedback"
                                  v-if="formData.team_shared == true && formData.shared == true">You can not share with both team and community, please choose one.</span>

                            <div class="form-btn">

                                <button class="btn btn-primary"
                                        v-if="!formData.name || busy || (formData.team_shared == true && formData.shared == true)"
                                        disabled="true"
                                >{{ saveBtnText }}
                                </button>
                                <button class="btn btn-primary"
                                        v-else
                                        @click.prevent="saveDoc()"
                                >{{ saveBtnText }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid" v-else>
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <div v-if="activeEmbedHTML" class="embed-responsive embed-responsive-16by9" id="embed-video" v-html="activeEmbedHTML">
                    </div>
                    <div v-else class="centered gray-bg">
                        <img src="/assets/img/no_videos_icon.svg" />
                    </div>
                </div>
                <div class="col-sm-12 col-md-6 rightside-part">
                    <div class="row">
                        <div class="col-1 col-lg-1 col-md-0 px-2 empty-space">&nbsp;</div>
                        <div class="col-11 col-lg-11 col-md-12 pl-2 mb-2">
                            <div class="row">
                                <div class="col-3 pr-0"
                                     @focusout="hideSortOptions($event)"
                                     tabindex="0">
                                    <div class="sort-icon" @click="sortOptions  = !sortOptions">
                                        <img src="/assets/img/playlist_sort.svg" width="24" height="24"/>
                                        SORT
                                    </div>

                                    <div class="sort-dropdown" v-if="sortOptions"
                                         ref="memberOption">
                                        <ul>
                                            <li><a href="javascript:;" @click="sort('asc')" >Date Added (Newest)</a></li>
                                            <li><a href="javascript:;" @click="sort('desc')" >Date Added (Oldest)</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-9 pl-0 pl-md-2" style="padding-left: 0px; margin-left: -10px;"
                                     v-if="userData && userData.id == documentData.user.id"
                                     @focusout="hideInput($event)"
                                     tabindex="0">
                                    <a class="add-video" @click="toggleVideoInput();"
                                       >
                                        <img src="/assets/img/plus.svg" width="12" height="12" />
                                        ADD VIDEO
                                    </a>

                                        <div class="input-url fn-search"
                                             v-if="toggleInput"
                                            >
                                            <div class="fn-search-form">
                                                <input type="text" :ref="'youtube_url'"
                                                       @paste="getVideoInfo($event)"
                                                       @keyup="getVideoInfo($event, true)"
                                                       v-model="newVideoLink" placeholder="Paste here a YouTube vide Link..." />
                                                <p v-if="errorMsg" class="text-danger">{{ errorMsg }}</p>
                                                <div class="row" v-if="newVideoLink && newVideoInfo.title">
                                                    <div class="col-md-5">
                                                        <img :src="newVideoInfo.thumbnail_url" style="width:100%;"/>
                                                    </div>
                                                    <div class="col-md-7 pl-0">
                                                        <strong>{{ newVideoInfo.title }}</strong>
                                                        <p class="p-0">{{ newVideoInfo.author_name }}</p>
                                                    </div>
                                                </div>
                                                <div class="row" v-if="newVideoLink && newVideoInfo.title">
                                                    <div class="col" style="display: contents;">
                                                        <button class="btn btn-rounded-primary mx-auto" @click="addToPlaylist">Add to Playlist</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <draggable v-if="videos.length > 0 && userData && (userData.id == documentData.user.id)"
                               v-model="videos"
                               @change="update"
                               id="right-video-list">
                       <div class="row"
                            v-for="video in videos"
                            :key="video.id"
                            v-show="!busy"
                            @click="activeEmbedHTML = video.html"
                       >
                        <div class="col-lg-1 col-md-4 col-xs-2 py-md-2" style="display: flex; align-items: center;">
                            <svg style=""
                                 class="move-icon"
                                 fill="none" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4 8h16M4 16h16" stroke="#4A5568" stroke-linecap="round"
                                      stroke-linejoin="round" stroke-width="2"/>
                            </svg>
                        </div>
                        <div class="col-lg-11 col-md-10 col-xs-10 p-md-2 video-selection">
                            <div class="row">
                                <div class="col-3 col-lg-3 col-md-4">
                                    <img :src="video.thumbnail_url" style="width:100%;"/>
                                </div>
                                <div class="col-6 col-lg-7 col-md-6 pl-0">
                                    <strong>{{ video.title }}</strong>
                                    <p>{{ video.author_name }}</p>
                                </div>
                                <div class="col-3 col-lg-2 col-md-2" style="display: flex; align-items: center;"
                                     @focusout="hideOption($event);"
                                     tabindex="1">
                                    <svg
                                        v-if="userData && userData.id == documentData.user_id"
                                        @click="activeOption = video.id"
                                         style="margin:auto; display: block;"
                                         fill="none" height="24" stroke="currentColor" stroke-linecap="round"
                                         stroke-linejoin="round" stroke-width="1.5" width="24"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="12" cy="12" r="1"/>
                                        <circle cx="19" cy="12" r="1"/>
                                        <circle cx="5" cy="12" r="1"/>
                                    </svg>

                                    <div class="delete-dropdown" v-if="video.id == activeOption"
                                         ref="memberOption">
                                        <ul>
                                            <li><a href="javascript:;" @click="remove(video)" class="red-txt">Delete</a></li>
                                        </ul>
                                    </div>


                                </div>
                            </div>
                        </div>

                    </div>
                    </draggable>
                    <div v-else-if="videos.length > 0" class="row"
                         v-for="video in videos"
                         :key="video.id"
                         v-show="!busy"
                         @click="activeEmbedHTML = video.html"
                    >
                        <div class="col-lg-1 col-md-4 col-xs-2 py-md-2" style="display: flex; align-items: center;">
                            <svg style=""
                                 class="move-icon"
                                 fill="none" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4 8h16M4 16h16" stroke="#4A5568" stroke-linecap="round"
                                      stroke-linejoin="round" stroke-width="2"/>
                            </svg>
                        </div>
                        <div class="col-lg-11 col-md-10 col-xs-10 p-md-2 video-selection">
                            <div class="row">
                                <div class="col-3 col-lg-3 col-md-4">
                                    <img :src="video.thumbnail_url" style="width:100%;"/>
                                </div>
                                <div class="col-6 col-lg-7 col-md-6 pl-0">
                                    <strong>{{ video.title }}</strong>
                                    <p>{{ video.author_name }}</p>
                                </div>
                                <div class="col-3 col-lg-2 col-md-2" style="display: flex; align-items: center;"
                                     @focusout="hideOption($event);"
                                     tabindex="1">
                                    <svg
                                        v-if="userData && userData.id == documentData.user_id"
                                        @click="activeOption = video.id"
                                        style="margin:auto; display: block;"
                                        fill="none" height="24" stroke="currentColor" stroke-linecap="round"
                                        stroke-linejoin="round" stroke-width="1.5" width="24"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="12" cy="12" r="1"/>
                                        <circle cx="19" cy="12" r="1"/>
                                        <circle cx="5" cy="12" r="1"/>
                                    </svg>

                                    <div class="delete-dropdown" v-if="video.id == activeOption"
                                         ref="memberOption">
                                        <ul>
                                            <li><a href="javascript:;" @click="remove(video)" class="red-txt">Delete</a></li>
                                        </ul>
                                    </div>


                                </div>
                            </div>
                        </div>

                    </div>
                    <div v-else class="row">
                        <div class="centered">
                            <div class="hero">
                                <p class="text-center">- This playlist is empty -</p>
                                <p class="text-center">Add a video to this playlist.</p>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
        <doc-clone-name v-if="settingCloneTitle"></doc-clone-name>
        <DocumentContent :style=" (videos.length == 0) ? 'margin-top: -23px; ' : ''" />
    </div>
</template>

<script>
import DocumentHttpService from "../../services/DocumentHttpService";
import ApiService from "../../api/api.service";
import draggable from 'vuedraggable';

import DocumentContent from "./../DocumentContent";
import DocCloneName from "./../DocCloneName";
import {mapGetters} from "vuex";

export default {
    name: "Playlist",
    components: {
        ApiService,
        draggable,
        DocumentContent,
        DocCloneName
    },
    data: function () {
        return {
            setTitleState: false,

            formData: {
                entity_name: 'Playlist',
                entity_group: 'Playlist',
                name: '',
                description: '',
                shared: false,
                team_shared: false,
                temp_id: null,
            },

            share_tooltip: false,
            team_share_tooltip: false,
            userData: null,

            saveBtnText: 'SAVE',
            successUpdateMessage: '',


            busy: false,
            docService: new DocumentHttpService(),

            newVideoLink: '',
            newVideoInfo: {},
            errorMsg: '',
            videos: [],

            documentData: null,

            activeEmbedHTML: null,

            toggleInput: false,
            activeOption: null,
            sortOptions: false,
            settingCloneTitle: false,
        }
    },
    computed: {
        ...mapGetters({
            isLoggedIn: "isLoggedIn",
            getUser: 'getUser'
        })
    },
    mounted() {
        this.userData = JSON.parse(localStorage.getItem('user'));
        // this.busy = true;
        // div height of list of videos

        if (!this.$route.params.doc_id) {
            this.checkPaidPlanAccess();
            this.setTitleState = true;
        } else {
            // clone
            if(this.$route.query.clone) {
                this.settingCloneTitle = true;
            }

            this.load();
        }
    },
    created() {
        window.addEventListener("resize", this.setHeightOfList);
    },
    destroyed() {
        window.removeEventListener("resize", this.setHeightOfList);
    },
    methods: {
        checkPaidPlanAccess(latestThree) {
            // restriction check
            this.userData = JSON.parse(localStorage.getItem('user'));
            if(typeof latestThree == 'undefined') {
                if(this.userData.free_plan && this.userData.documents_count >= 3) {
                    this.$router.push({ name: 'Documents Limit'});
                }
            } else {
                if(this.userData.free_plan && !latestThree) {
                    this.$router.push({ name: 'Documents Limit'});
                }
            }
        },
        saveDoc(data, entityData) {

            this.busy = true;
            let postData = {};
            if(data) {
                postData = data;
                postData.entity_name = 'Playlist',
                postData.entity_group = 'Playlist',
                postData.entity_data = this.videos;
            } else {
                postData = this.formData;
            }



            this.docService.store(postData)
                .then(({data}) => {
                        this.documentData = data.doc;
                        this.$router.push({params: {doc_id: data.doc.document_id}})
                        this.setTitleState = false;

                        this.setHeightOfList();
                    }
                )
                .catch((response) => {
                    console.log(response);
                })
            ;
        },

        load() {
            ApiService.setHeader();
            ApiService.get('/api/document/' + this.$route.params.doc_id)
                .then(({data}) => {
                    this.documentData = data.doc;
                    this.videos = data.entity.embed_videos;
                    if(this.videos.length) {
                        this.activeEmbedHTML = this.videos[0].html;
                    }

                    this.setHeightOfList();
                })
                .catch(() => {
                })
        },

        setHeightOfList() {
            setTimeout(() => {
                let elmnt = document.getElementById("embed-video");
                if(document.getElementById("right-video-list")) {
                    document.getElementById("right-video-list").style.maxHeight = (elmnt.offsetHeight - 22) + "px";
                }


                this.busy = false;
            }, 200);
        },

        async getVideoInfo(e, keyUp = false) {
            this.errorMsg = '';
            this.newVideoInfo = '';

            try {
                let url = '';
                if(keyUp) {
                    if(! e.target.value) {
                        return;
                    }
                    url = 'https://www.youtube.com/oembed?format=json&url=' + e.target.value;
                } else {
                    if(! e.clipboardData.getData('text')) {
                        return;
                    }
                    url = 'https://www.youtube.com/oembed?format=json&url=' + e.clipboardData.getData('text')
                }
                const res = await fetch(url);
                this.newVideoInfo = await res.json();
                this.newVideoInfo.id = this.getVideoId(this.newVideoLink)
            } catch (err) {
                this.errorMsg = 'Please use a valid Youtube URL.';
            }
        },

        getVideoId(url) {
            var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
            var match = url.match(regExp);
            return (match&&match[7].length==11)? match[7] : false;
        },
        addToPlaylist() {
            if(this.videos.findIndex((vid) => vid.id === this.newVideoInfo.id) === -1) {
                this.newVideoInfo.date_added = Date.now();
                this.videos.push(this.newVideoInfo);

                this.activeEmbedHTML = this.newVideoInfo.html;


                this.newVideoInfo = {};
                this.newVideoLink = '';

                // update in the database
                this.update();
            } else {
                this.toggleInput = true;
                this.errorMsg = 'Video is already exists in this playlist.'
            }



        },

        remove(vid) {
            this.videos = this.videos.filter((video) => video.id !== vid.id);

            // update in the database
            this.update('remove');
        },

        update(action = 'add') {
            ApiService.setHeader();
            ApiService.put('/api/document/' + this.documentData.id,
                {
                    user_id: this.documentData.user_id,
                    entity_id: this.documentData.entity_id,
                    name: this.documentData.name,
                    description: this.documentData.description,
                    entity_name: this.documentData.entity_name,
                    entity_group: this.documentData.entity_group,
                    embed_videos: this.videos
                })
            .then(({data})=> {
                if(this.videos.length) {
                    if(action == 'remove') {
                        this.activeEmbedHTML = this.videos[0].html;
                    } else {
                        this.activeEmbedHTML = this.videos[this.videos.length - 1].html;
                    }

                } else {
                    this.activeEmbedHTML = '';
                }

            })
            .catch((response) => {
                console.log(response);
            });
        },
        hideInput(e) {
            if (!e.currentTarget.contains(e.relatedTarget)) {
                this.toggleInput = false;
                this.newVideoLink = '';
            }
        },

        hideOption(e) {
            if (!e.currentTarget.contains(e.relatedTarget)) {
                this.activeOption = null;
            }
        },

        hideSortOptions(e) {
            if (!e.currentTarget.contains(e.relatedTarget)) {
                this.sortOptions = false;
            }
        },

        toggleVideoInput() {
            this.toggleInput = !this.toggleInput;
            this.$nextTick(() => {
                this.$refs['youtube_url'].focus();
            });
            if(! this.toggleInput) {
                this.newVideoLink = '';
            }
            this.errorMsg = '';
        },

        sort( order = 'desc' ) {
            this.videos.sort((a, b) => {
                if(order == 'desc') {
                    return new Date(a.date_added) - new Date(b.date_added);
                } else {
                    return new Date(b.date_added) - new Date(a.date_added);
                }
            });
            this.sortOptions = false;
        }
    }
}
</script>

<style scoped>
h4.sub-heading {
    font-weight: 400;
    font-size: 1.8em;
}

.video-selection {
    border-bottom: 1px solid #e4e4e4;
    cursor: pointer;
}

.video-selection:hover {
    background-color: #f7f7f7;
}
/*.sort-icon svg {*/
/*    display:none;*/
/*    cursor: pointer;*/
/*}*/
.sort-video:hover {
    display:block;
}

.fn-search {
    width: 360px;
    max-width: 100%;
    position: relative;
    z-index: 5;
}

.centered {
    margin: auto;
    height:45vh;
    display: flex;
    justify-content: center;
    align-items: center;
}

.centered .hero {
}
.centered .hero p {
    font-size: 2.5em;
    font-weight: 300;
}


.fn-search-form input {
    border: none;
    padding: 12px 35px 12px 20px;
    font-size: 16px;
    border-radius: 8px;
    width: 100%
}
.fn-search-form p, .fn-search-form div {
    padding: 10px 20px;
}
.fn-search-form {
    position: absolute;
    top: 0;
    right: 25px;
    box-shadow: 0 10px 20px 5px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    width: 450px;
    max-width: 80vw;
    background-color: #ffffff;
}
.gray-bg {
    background-color: #f7f7f7;
    margin-bottom: -50px;
}
.sort-icon, .add-video {
    font-weight: 500;
    cursor: pointer;
}

.rightside-part {
    margin: 0px auto;
}
@media screen and (max-width: 767px) {
    .rightside-part {
        margin: 20px auto;
    }
}

@media screen and (max-width: 991px) {
    .page-wrapper {
        margin:auto 0px;
    }
    .empty-space { display:none; }

}

@media screen and (min-width: 992px) {
    .page-wrapper {
        margin:auto -50px auto -75px;
    }

    .fn-search {
        width: 380px;
    }


}

@media screen and (min-width: 1025px) {
    .fn-search {
        width: 450px;
    }
}

.main-content-comments {
    margin-top: 0px;
}

.delete-dropdown {
    position: absolute;
    right: 90px;
    top: 40px;
    width: 156px;
    box-shadow: 0 5px 15px rgb(0 0 0 / 20%);
    border-radius: 6px;
    background-color: #ffffff;
    z-index: 1;
    display: block;
}

.delete-dropdown ul{
    margin: 0;
    padding: 7px 0;
}
.delete-dropdown ul li{
    display: block;
    list-style-type: none;
}
.delete-dropdown ul li a{
    font-family: 'Poppins', sans-serif;
    display: block;
    padding: 7px 15px;
}
.delete-dropdown ul li a.active,
.delete-dropdown ul li a.active:hover{
    background: #EBECEE;
    color: #16181F;
}
.delete-dropdown ul li a:hover{
    color: #1E73BD;
}


.sort-dropdown {
    position: absolute;
    left: 0px;
    top: 30px;
    width: 182px;
    box-shadow: 0 5px 15px rgb(0 0 0 / 20%);
    border-radius: 6px;
    background-color: #ffffff;
    z-index: 1;
    display: block;
}

.sort-dropdown ul{
    margin: 0;
    padding: 7px 0;
}
.sort-dropdown ul li{
    display: block;
    list-style-type: none;
}
.sort-dropdown ul li a{
    font-family: 'Poppins', sans-serif;
    display: block;
    padding: 7px 15px;
}
.sort-dropdown ul li a.active,
.sort-dropdown ul li a.active:hover{
    background: #EBECEE;
    color: #16181F;
}
.sort-dropdown ul li a:hover{
    color: #1E73BD;
}

.sort-icon img {
    padding-bottom: 5px;
    margin-right: 5px;
}
.add-video img {
    padding-bottom: 3px;
    margin-right: 5px;
}
svg.move-icon {
    margin:auto;
    display: none;
}
.sortable-chosen svg.move-icon {
    display: block;
}

#right-video-list {
    width:100%;
    overflow-x: hidden;
    overflow-y: scroll;
}
</style>
